import React from "react";
import DashboardTitle from "./DashboardTitle";
import { FilePicker } from 'react-file-picker'
import ProgressBar from "@ramonak/react-progress-bar";
import themes from "../themes";
import importFattura from "../services/importFattura";
import readXlsxFile from 'read-excel-file'
import Utils from "../utils/utils";

let username;
let token;
export default class ImportExcelDialog extends React.Component {
    constructor(props) {
        super(props);

        username = this.props.credenziali.user;
        token = this.props.credenziali.tok;
        
        this.state = {
            fatture: [], 
            imported: false, 
            sent: 0
        };
    }

    readUploadFile(file) {

        readXlsxFile(file).then(fatture => {
            this.setState({ fatture, imported: true });
                
            setTimeout(() => {
                this.startImport();
            }, 100);
        });
    }

    async startImport() {

        var sent = 0;
        var errors = [];
        var total = this.state.fatture.length;
        var index = 0;
        for (const fattura of this.state.fatture) {
            if (index < 2) {
                index++;
                continue;
            }
            
            sent++;
            let perc = parseInt((sent/total)*100);

            var finalImporto = String(fattura[6]);
            finalImporto = Utils.getNumberString(finalImporto);
            if (!finalImporto.includes(',')) {
                finalImporto += ',00';
            }
            if (finalImporto.split(',')[1].length === 1) {
                finalImporto += '0';
            }

            // Upload fattura
            let fat = {
                ragione_sociale: fattura[0], 
                tipo: fattura[1], 
                numero: fattura[2], 
                data: fattura[3], 
                sdi: fattura[5], 
                importo: finalImporto, 
            }
            
            let res = await importFattura(username, token, fat);
            if (res.result !== 'ok' && res.error === undefined) {
                errors.push({ mittente: fat.ragione_sociale, numero: fat.numero});
            }
            
            this.setState({ sent: perc });
            index++;
        }

        if (errors.length > 0) {
            var alertMsg = "Attenzione! Alcune fatture non sono state importate correttamente. Nello specifico:\n";
            errors.forEach(e => alertMsg += "• Fattura " + e.numero + " di: " + e.mittente + ";\n");
            alert(alertMsg);
            this.setState({ imported: false });
            return;
        }

        this.setState({ imported: false });

    }

    render() {

        return(
            <div style={backView} onClick={(e) => {
                if (!this.state.imported) {
                    this.props.onEnd();
                }
            }}>
                <div style={importView} onClick={(e) => e.stopPropagation()}>
                    <DashboardTitle icon={require('../images/import.png')} title={"Importa fatture"} />
                    {!this.state.imported ? <FilePicker
                        extensions={['xls', 'xlsx']}
                        onChange={file => {
                            this.readUploadFile(file);
                        }}
                        onError={errMsg => {
                            alert(errMsg);
                        }} >
                        <div style={{ width: '100%', height: '150px', border: '2px solid lightgrey', borderRadius: 15, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                            <img src={require('../images/import_2.png')} alt="" style={{ width: 50, height: 50, opacity: 0.4, marginTop: 10 }} />
                            <h3 style={{ opacity: 0.4, fontWeight: 'bold', textAlign: 'center' }}>Clicca qui per importare il file MSExcel delle fatture</h3>
                        </div>
                    </FilePicker> :
                    <div style={{ width: '100%', height: '150px', border: '2px solid lightgrey', borderRadius: 15, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                        <img src={require('../images/cloud-computing.png')} alt="" style={{ width: 50, height: 50, opacity: 0.4, marginBottom: 10 }} />
                        <ProgressBar width='480px' bgColor={themes.default.palette.primary.main} completed={this.state.sent} maxCompleted={100} />
                    </div>
                    }
                </div>
            </div>
        );
    }
}

const backView = {
    backgroundColor: '#00000033', 
    width: '100%', 
    height: '100%', 
    position: 'absolute', 
    display: 'flex', 
    flexDirection: 'row', 
    alignItems: 'center', 
    justifyContent: 'center',
    top: 0, 
    left: 0, 
}

const importView = {
    backgroundColor: 'white', 
    boxShadow: '0px 2px 10px lighgrey', 
    borderRadius: 15, 
    padding: 30, 
    width: '600px',
}